/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClipboardCheck} from '@fortawesome/pro-duotone-svg-icons';

const InstituteFormsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faClipboardCheck} {...props} />
);

export default InstituteFormsIcon;
